// Force-change-password page shown immediately after login when the
// user record has must_change_password = 1 (i.e. the admin issued a
// temporary password).

import { useState } from 'react';
import { auth } from '../lib/api';
import { useStore } from '../state/store';

export function ChangePasswordPage() {
  const setAuthUser = useStore((s) => s.setAuthUser);
  const user = useStore((s) => s.authUser);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(ev: React.FormEvent): Promise<void> {
    ev.preventDefault();
    if (next !== confirm) {
      setError('New passwords do not match');
      return;
    }
    if (next.length < 12) {
      setError('Password must be at least 12 characters');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await auth.changePassword(current, next);
      // Mark the user as no longer requiring a change.
      if (user) setAuthUser({ ...user, mustChangePassword: false });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  async function logout(): Promise<void> {
    await auth.logout();
    setAuthUser(null);
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={(e) => void submit(e)}>
        <h1>Set a new password</h1>
        <p className="muted">
          Your account was created with a temporary password. Choose a new
          password before continuing. Minimum 12 characters.
        </p>
        <label>
          Current (temporary) password
          <input
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        <label>
          New password
          <input
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            autoComplete="new-password"
            required
            minLength={12}
          />
        </label>
        <label>
          Confirm new password
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            required
            minLength={12}
          />
        </label>
        {error && <div className="login-error">{error}</div>}
        <div className="settings-actions">
          <button type="submit" disabled={busy}>{busy ? 'Saving…' : 'Set password'}</button>
          <button type="button" onClick={() => void logout()}>Sign out</button>
        </div>
      </form>
    </div>
  );
}
